module.exports = __webpack_public_path__ + "img/build1.5888ccea.png";